export default "__VITE_ASSET__DD5nDR8K__"